let pendingScheduledPopoverItemId: string | undefined;

export function queueScheduledPopoverOpen(itemId: string | undefined): void {
    pendingScheduledPopoverItemId = itemId;
}

export function consumeScheduledPopoverOpen(itemId: string | undefined): boolean {
    if (!itemId || pendingScheduledPopoverItemId !== itemId) {
        return false;
    }
    
    pendingScheduledPopoverItemId = undefined;
    return true;
}
